import React, { useRef } from "react";
import IdleTimer from "react-idle-timer";

const IdleTimerContainer = () => {
  const idleTimerRef = useRef(null);

  const onIdle = () => {
    window.location.reload();
  };
  return (
    <div>
      <IdleTimer
        ref={idleTimerRef}
        timeout={30 * 1000}
        onIdle={onIdle}
      ></IdleTimer>
    </div>
  );
};

export default IdleTimerContainer;
